import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { fileUrl } from "../lib/api";
import Logo from "./Logo";
import { Button } from "./ui/button";
import { LogOut } from "lucide-react";

export default function DashboardShell({ title, subtitle, children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => { await logout(); navigate("/"); };
  const initials = (user?.name || "U").split(" ").map((p) => p[0]).slice(0, 2).join("").toUpperCase();

  return (
    <div className="min-h-screen bg-[#FAFAF9]">
      <header className="gdf-navy-bg text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
          <button onClick={() => navigate("/")} className="bg-white/95 rounded-lg px-2 py-1.5"><Logo className="h-8" /></button>
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-2">
              {user?.picture ? (
                <img src={fileUrl(user.picture)} alt="" className="h-9 w-9 rounded-full object-cover border-2 border-emerald-400" />
              ) : (
                <div className="h-9 w-9 rounded-full bg-emerald-500 flex items-center justify-center text-sm font-bold">{initials}</div>
              )}
              <div className="hidden sm:block leading-tight">
                <p className="text-sm font-semibold">{user?.name}</p>
                <p className="text-[11px] text-emerald-300 capitalize">{user?.role}</p>
              </div>
            </div>
            <Button onClick={handleLogout} data-testid="dashboard-logout" size="sm" className="bg-white/10 hover:bg-white/20 text-white"><LogOut className="w-4 h-4" /></Button>
          </div>
        </div>
      </header>
      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-8">
        <div className="mb-6">
          <h1 className="text-2xl sm:text-3xl font-head font-bold text-[#0A192F]">{title}</h1>
          {subtitle && <p className="text-slate-500 mt-1">{subtitle}</p>}
        </div>
        {children}
      </main>
    </div>
  );
}
